










































import { Vue, Component } from "vue-property-decorator";
import Auth from "@/models/auth";
import { formRules } from "@/const/form-rules";
import logo from "@/assets/logo.jpg";

@Component
export default class Login extends Vue {
  rules = formRules;
  formIsValid = true;
  email = "";
  password = "";
  isLoggingIn = false;
  isLoginError = false;
  logo = logo;

  async onClick() {
    this.validateForm();

    if (this.formIsValid) {
      await this.login();
    }
  }

  private async login() {
    this.isLoggingIn = true;
    try {
      await Auth.login(this.email, this.password);
    } catch (error) {
      this.isLoginError = true;
      this.isLoggingIn = false;
    }
  }

  private validateForm() {
    (this.$refs.form as Vue & { validate: () => boolean }).validate();
  }
}
